// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_evidence.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { DecideRfiDraftRequest, DecideRfiDraftResponse, GetRfiEvidenceStateRequest, GetRfiEvidenceStateResponse, RegisterRfiManualDraftRequest, RegisterRfiManualDraftResponse, RenderRfiOutwardRequest, RenderRfiOutwardResponse, ResolveRfiEvidenceContextRequest, ResolveRfiEvidenceContextResponse, ReviewRfiDraftRequest, ReviewRfiDraftResponse } from "./rfi_evidence_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Browser edge: authenticated tenant/actor, RFI route resolution and target
 * authorization precede all metadata reads. No framework registration here.
 *
 * @generated from service mono.projectdata.v1.RfiEvidenceService
 */ export const RfiEvidenceService = {
    typeName: "mono.projectdata.v1.RfiEvidenceService",
    methods: {
        /**
     * Picker discovery uses LibraryReleaseService.ListSelectableReleases and
     * ArtifactService.ListEntityArtifacts(entity_type=rfi_response_project,
     * entity_id=canonical RFI id). Both apply CURRENT caller permissions; never
     * use raw gateway listings, unfiltered totals or source Program grants.
     *
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.ResolveRfiEvidenceContext
     */ resolveRfiEvidenceContext: {
            name: "ResolveRfiEvidenceContext",
            I: ResolveRfiEvidenceContextRequest,
            O: ResolveRfiEvidenceContextResponse,
            kind: MethodKind.Unary
        },
        /**
     * Reopen by target, without a browser-cached draft id. No answer bytes here.
     *
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.GetRfiEvidenceState
     */ getRfiEvidenceState: {
            name: "GetRfiEvidenceState",
            I: GetRfiEvidenceStateRequest,
            O: GetRfiEvidenceStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.RegisterRfiManualDraft
     */ registerRfiManualDraft: {
            name: "RegisterRfiManualDraft",
            I: RegisterRfiManualDraftRequest,
            O: RegisterRfiManualDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.ReviewRfiDraft
     */ reviewRfiDraft: {
            name: "ReviewRfiDraft",
            I: ReviewRfiDraftRequest,
            O: ReviewRfiDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.DecideRfiDraft
     */ decideRfiDraft: {
            name: "DecideRfiDraft",
            I: DecideRfiDraftRequest,
            O: DecideRfiDraftResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiEvidenceService.RenderRfiOutward
     */ renderRfiOutward: {
            name: "RenderRfiOutward",
            I: RenderRfiOutwardRequest,
            O: RenderRfiOutwardResponse,
            kind: MethodKind.Unary
        }
    }
};
